import { z } from 'zod';
import { APP_CONSTRAINTS, APP_VALIDATION_PATTERNS } from '@/lib/constants/app';

export const appWebCreateFormSchema = z.object({
  customName: z
    .string()
    .min(APP_CONSTRAINTS.CUSTOM_NAME_MIN, 'Subdomain is required')
    .max(APP_CONSTRAINTS.CUSTOM_NAME_MAX)
    .regex(APP_VALIDATION_PATTERNS.CUSTOM_NAME, 'Lowercase letters, numbers, and single hyphens only. Must start and end with a letter or number.'),
  sharedDomainId: z.number(),
});

export type AppWebCreateFormSchemaData = z.infer<typeof appWebCreateFormSchema>;
